import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultObjectiveResource,
    ObjectiveMutationResourceSchema,
    useObjectiveActions,
} from '../../../../../resource/resources/artifacts/objective/objectiveResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { ObjectiveContent } from './ObjectiveContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const ObjectiveView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const objectiveActions = useObjectiveActions()
    const objectiveQuery = objectiveActions.useGetResource(id);
    const updateObjective = objectiveActions.useUpdateResource();
    const validateObjective = objectiveActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: ObjectiveMutationResourceSchema,
        defaultValues: defaultObjectiveResource,
        submitHandler: async (data) => {
            await updateObjective.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: objectiveQuery.data,
    });

    return (
        <QueryBaseComponent name="Objective" query={objectiveQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateObjective.data}
                    metaDataInfo={objectiveQuery.data}
                    resourceType={ResourceType.OBJECTIVE}
                >
                    <Text c="dimmed">Objective</Text>
                </ResourceValidationTitleBar>
                <ObjectiveContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
